export const DEV_BEARER_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJwYXZhbmJwMTAyazIyQGdtYWlsLmNvbSIsImV4cCI6MTc2MTgyNjg3Mn0.KDAEmvQY7LzqiporfB78xI1MDFrAK38ZRyzb0fXCaU4';

export const DEV_USER = {
    name: "Pavan",
    email: "pavanbp102k22@gmail.com",
    restaurant_id: 101,
    location: "kphb",
    role: "admin",
    permissions: ["view_orders", "edit_orders", "view_menu", "edit_menu", "view_live_orders", "manage_live_orders", "view_dashboard", "view_calendar", "manage_calendar", "view_payments", "manage_payments", "view_inventory", "manage_inventory"],
  };
